import { gql, useMutation } from '@apollo/client';

export const SIGN_IN_MUTATION = gql`
  mutation Login($identifier: String!, $password: String!) {
    login(input: { identifier: $identifier, password: $password }) {
      token
      refreshToken
      id
    }
  }
`;

export const useSignInMutation = () => {
  return useMutation(SIGN_IN_MUTATION);
};
